import { Canvas } from "fabric";

class SceneHistory {

  private undoStack: string[] = [];
  private redoStack: string[] = [];

  save(canvas: Canvas) {

    const json = JSON.stringify(canvas.toJSON());

    this.undoStack.push(json);

    // Once a new action happens,
    // redo history is no longer valid.
    this.redoStack = [];

  }

  undo(canvas: Canvas) {

    if (this.undoStack.length <= 1) return;

    const current = this.undoStack.pop();

    if (current) {
      this.redoStack.push(current);
    }

    const previous = this.undoStack[this.undoStack.length - 1];

    canvas.loadFromJSON(previous).then(() => {
      canvas.renderAll();
    });

  }

  redo(canvas: Canvas) {

    if (this.redoStack.length === 0) return;

    const state = this.redoStack.pop();

    if (!state) return;

    this.undoStack.push(state);

    canvas.loadFromJSON(state).then(() => {
      canvas.renderAll();
    });

  }

}

export const sceneHistory = new SceneHistory();